import React from 'react'

import { connect } from 'react-redux'
import debounce from 'debounce'
import { actions as formActions } from 'react-redux-form'
import get from 'react-redux-form/utils/get'
import { Segment } from "semantic-ui-react";
import RichTextEditor from "../richText/RichTextEditor";
import { DynamicRichTextRender } from "../richText/RichTextRender";

class SemanticRichTextWidget extends React.Component {

  constructor(props) {
    super(props);
    this.state = { slateValue: null }
    this.debouncedCommit = debounce((value) => this.props.dispatchChange(value), 400)
  }

  componentWillUnmount() {
    this.debouncedCommit.cancel()
  }

  handleChange = (value) => {
    // Slate fires onChange on selection-only changes too; those serialize identically, so skip
    // them — otherwise we'd commit (and draft) when nothing actually changed.
    if (value === this.state.slateValue) return
    this.setState({ slateValue: value })
    this.debouncedCommit(value)
  }

  handleBlur = () => {
    this.debouncedCommit.cancel()
    if (this.state.slateValue !== null) this.props.dispatchChange(this.state.slateValue)
  }


  render() {
    const { mentionOptions, mentionExamples, useTemplates, textWillBeUsedInPdf, editorKey } = this.props.options

    if (this.props.readonly) {
      return  <Segment style={{ marginTop: '0em' }} secondary>
        <DynamicRichTextRender renderHtml content={this.props.exampleText}/>
      </Segment>
    }

    return (
      <div>
        {/* The editor only reads its value on mount; changing editorKey remounts it to show a value set from outside */}
        <RichTextEditor key={editorKey}
                        serializeToHtml={this.props.serializeToHtml}
                        onChange={this.handleChange}
                        value={this.props.value}
                        mentionOptions={mentionOptions}
                        useTemplates={useTemplates}
                        textWillBeUsedInPdf = {textWillBeUsedInPdf}
                        loading = {this.props.loading}
                        onBlur={this.handleBlur}
        />
        {mentionOptions && mentionExamples ?
          <div className="field">
            <label>{I18n.t('components.rich_text.example')}</label>
            <Segment style={{ marginTop: '0em' }} secondary>
              <DynamicRichTextRender renderHtml content={this.props.exampleText}/>
            </Segment>
          </div> : null}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { mentionOptions, mentionExamples } = ownProps.options

  let fullModel = `${ownProps.model}.${ownProps.id}`

  let modelName = ownProps.model && ownProps.model.split('.')[1]
  let loadModel = `meta.${modelName}.loading`

  let value = get(state, fullModel)
  let exampleText = value

  if(mentionOptions && mentionExamples && exampleText) {
    mentionOptions.forEach((keyword, index) => {
      exampleText = exampleText.replaceAll(`@mention{${keyword}}`, mentionExamples[index]);
    })
  }

  return {
    value: get(state, fullModel),
    exampleText: exampleText,
    loading: get(state, loadModel),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  let fullModel = `${ownProps.model}.${ownProps.id}`

  return {
    dispatchChange:(value) => {
      dispatch(formActions.change(fullModel, value))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SemanticRichTextWidget);
